import { subject } from "@casl/ability";
import { useQuery } from "@tanstack/react-query";
import { FirestoreError } from "firebase/firestore";
import { QUERY_KEY } from "@/modules/tipos-de-respostas/components/tipos-de-respostas-table/TiposDeRespostasTable";
import useUserStore from "@/modules/users/store";
import { getTiposDeRespostas } from "../../firestore";

type TGetTiposDeRespostasResponse = Awaited<ReturnType<typeof getTiposDeRespostas>>;

/**
 * Get questionário de inovação query hook
 * @returns Questionário de inovação query hook
 */
function useQueryTiposDeRespostas() {
  const activeEmpresaId = useUserStore((store) => store.activeEmpresaId);

  return useQuery<TGetTiposDeRespostasResponse, FirestoreError, TTiposDeRespostas[]>({
    queryKey: ["empresas", { id: activeEmpresaId }, QUERY_KEY],
    queryFn() {
      if (!activeEmpresaId) {
        throw new Error("Empresa não selecionada");
      }
      return getTiposDeRespostas(activeEmpresaId);
    },
    select(dataResponse) {
      if (dataResponse.empty) {
        return [];
      }
      return dataResponse.docs.map((document_) => subject("TTiposDeRespostas", document_.data()));
    }
  });
}

export default useQueryTiposDeRespostas;
